import { Navigate } from "react-router-dom";
import {useUser} from "../../context/useUser";

const AuthenticatedRoute = ({ children }) => {
    const { user } = useUser()
    if (!user) {
        return <Navigate to="/" replace />;
    }
    return children;
};

export default AuthenticatedRoute;
